import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getSsd, updateSsd } from '@api/ssd';
import { message } from 'antd';
import type { AxiosError } from 'axios';

// --- constants ---
const SSD_QUERY_KEY = ['get-ssd', 'ei'];
const STALE_TIME = 5 * 60 * 1000; // 5 min
const LOADING_KEY = 'ssdLoadingMessage';
const MESSAGE_DURATION = 2;
const CLEANUP_DELAY = 5000;

// --- hooks ---
export const useSsdList = (ssdType: string) =>
  useQuery([SSD_QUERY_KEY, ssdType], () => getSsd(ssdType), {
    retry: 3,
    refetchOnWindowFocus: false,
    staleTime: STALE_TIME,
  });

export const useUpdateSsd = () => {
  const queryClient = useQueryClient();

  return useMutation(updateSsd, {
    onMutate: () => {
      message.loading({
        content: 'Action in progress...',
        key: LOADING_KEY,
        duration: 0,
      });
    },
    onSuccess: (data, variables) => {
      message.success({ content: data.message, duration: MESSAGE_DURATION, key: LOADING_KEY });
      queryClient.invalidateQueries([SSD_QUERY_KEY, variables.ssdType]);
    },
    onError: (error: AxiosError) => {
      const errorMessage =
        (error.response?.data as any)?.message || error.message || 'Something went wrong';
      message.error({ content: errorMessage, duration: MESSAGE_DURATION, key: LOADING_KEY });
    },
    onSettled: () => {
      setTimeout(() => message.destroy(LOADING_KEY), CLEANUP_DELAY);
    },
  });
};
